
import React, { useState, useEffect } from 'react';
import { Card, Button, Popconfirm, message } from 'antd';
import { RightOutlined, DeleteOutlined } from '@ant-design/icons';
import './user.css';
import { useNavigate } from 'react-router-dom'
import EditDatabaseModal from "../../components/alterUser/index";

const User = () => {

  const [userName, setUserName] = useState('name')
  const [password, setPassword] = useState('password')
  const [email, setEmail] = useState('')
  const [useid] = useState(localStorage.getItem("token").split('+')[1])
  const [visible, setVisible] = useState(false);
  const [fieldType, setFieldType] = useState('');
  const navigate = useNavigate()
  const [userInfo] = useState({
    id: useid,
    name: userName,
    email: email,
    password: password
  });

  const handleEditClick = (fieldType) => () => {
    console.log(1111);
    setFieldType(fieldType);
    setVisible(true);
  };

  const handleOk = (newValue) => {
    if (Object.keys(newValue) === 'email') {
      localStorage.setItem("token", `${newValue.email}+${useid}`);
      setEmail(newValue.email)
    }
    setVisible(false);
    getUserDetail(useid)
  };

  const onCancel = () => {
    setVisible(false);
  };


  const logout = () => {
    localStorage.removeItem('token')
    navigate('/login')
  }

  //确定注销
  const confirmDestroy = (e) => {
    deleteUser(useid)
    logout()
    message.success('Account canceled successfully ');
  };
  //取消注销
  const cancelDestroy = (e) => {
    console.log(e);
    message.error('Cancel account cancellation');
  };



  const getUserDetail = async (useid) => {
    try {
      const response = await fetch(`//dai.caihuiltd.com/api/get-user/${useid}`, {
        method: 'GET',
        mode: 'cors',
      })
      // 检查响应状态
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      // 解析JSON数据
      const result = await response.json();
      setUserName(result.data[0].name)
      setPassword(result.data[0].password)
      setEmail(result.data[0].email)
      userInfo.email = result.data[0].email
      userInfo.name = result.data[0].name
      userInfo.password = result.data[0].password
    } catch (error) {
      console.error('Error fetching database detail:', error);
    }
  };


  const deleteUser = async (useid) => {
    try {
      const response = await fetch(`//dai.caihuiltd.com/api/delete-user/${useid}`, {
        method: 'DELETE',
        mode: 'cors',
      })
      // 检查响应状态
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      // 解析JSON数据
      const result = await response.json();
      // 将数据存储到状态中
      console.log(result);
    } catch (error) {
      console.error('Error fetching database detail:', error);
    }
  };



  useEffect(() => {
    getUserDetail(useid);
    console.log(userName)
  }, []);

  useEffect(() => {
    console.log(userName)
  }, [userName]);


  return (
    <div className="user-info">
      <Card title={<div style={{ fontSize: '24px', fontWeight: 'bold' }}>
        Basic Information
      </div>} bordered={false} style={{ fontSize: 18 }} >
        {/* <div className="info-item">
          <span>Profile picture</span>
          <span>Add a profle picture to personalize your account</span>
          <Avatar icon="user" />
        </div> */}
        <div className="info-item">
          <span>User-name</span>
          <span>{userName}</span>
          <span onClick={handleEditClick('name')}><RightOutlined /></span>
        </div>
        <div className="info-item">
          <span>E-mail</span>
          <span>{email}</span>
          <span onClick={handleEditClick('email')}><RightOutlined /></span>
        </div>

        <div className="info-item">
          <span>Password</span>
          <span>•••••••••••••••</span>
          <span onClick={handleEditClick('password')}><RightOutlined /></span>
        </div>
      </Card>
      <div className="danger-zone">
        <p className="delete">Danger Zone If you want to permanently delete this account and all of its data.</p>

        <Popconfirm
          title="Delete the account "
          description="Are you sure to delete this account ?"
          onConfirm={confirmDestroy}
          onCancel={cancelDestroy}
          okText="Yes"
          cancelText="No"
        > <Button color="danger" variant="solid" icon={<DeleteOutlined />}>
            Delete
          </Button>
        </Popconfirm>

      </div>
      <Button type="primary" className="logout-button" onClick={logout}>
        Logout
      </Button>
      <EditDatabaseModal
        visible={visible}
        onOk={handleOk}
        onCancel={onCancel}
        fieldType={fieldType}
        currentValue={userInfo}
      />
    </div>
  );
};

export default User;